import { isEmpty } from 'lodash';
import {
  convertDateTimeToDate,
  convertToLocalDateTime,
  currentToDateTime
} from '@/common/utils/module/FormattingSupport';

export const focusOnInvalid = () => {
  const timeout = setTimeout(() => {
    const invalids = document.getElementsByClassName('valid on');
    const filtered = [...invalids].filter(element => element.tagName.toLowerCase() === 'div');

    if (filtered && filtered.length > 0) {
      const target = filtered[0];
      target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    clearTimeout(timeout);
  });
};

export const inputBlankTest = value => {
  if (isEmpty(value)) return false;
  if (value.trim() === '') return false;
  return true;
};

export const fileTypeValid = value => {
  if (isEmpty(value)) return false;
  if (!value.type.startsWith('image/')) return false;
  return true;
};

export const arrayFileTypeValid = value => {
  if (isEmpty(value)) return false;
  for (let file of value) {
    if (file.hasOwnProperty('storedFileName')) continue;
    if (!file.type.startsWith('image/')) return false;
  }
  return true;
};

export const videoTypeValid = value => {
  if (isEmpty(value)) return false;
  if (value.hasOwnProperty('storedFileName')) return true;
  if (!value.type.startsWith('video/')) return false;

  return true;
};

// datetime간 날짜비교
export const compareToDateTime = (dateTimeStr1, dateTimeStr2) => {
  const dateTime1 = convertToLocalDateTime(dateTimeStr1).replace(' ', 'T');
  const dateTime2 = convertToLocalDateTime(dateTimeStr2).replace(' ', 'T');
  // Date 객체로 변환
  const date1 = new Date(dateTime1);
  const date2 = new Date(dateTime2);
  // 날짜 비교
  return date1 < date2;
};

// date 와 datetime을 비교
export const compareToDateAndDateTime = (dateStr, dateTimeStr) => {
  const dateTime = convertDateTimeToDate(dateTimeStr);
  const date = new Date(dateStr);
  return date < dateTime;
};

export const compareToDateTimeAndDate = (dateTimeStr, dateStr) => {
  const dateTime = convertDateTimeToDate(dateTimeStr);
  const date = new Date(dateStr);
  return dateTime < date;
};

// date to date 비교
export const compareToDate = (dateStr1, dateStr2) => {
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);
  return date1 < date2;
};

export const compareToDateAndEqual = (dateStr1, dateStr2) => {
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);
  return date1 <= date2;
};

export const currentDateToDateStr = dateStr => {
  if (isEmpty(dateStr)) return false;
  const date1 = new Date();
  const date2 = new Date(dateStr);
  return date1 < date2;
};

// 현재시간을 datetime으로 변환하여 비교
export const currentDateToDateTimeStr = dateTimeStr => {
  const dateTime = dateTimeStr;
  const date = currentToDateTime();
  return dateTime < date;
};

export const isIdValid = value => {
  if (this.isEmpty(value)) return false;
  const regExp1 = /[0-9]/;
  const regExp2 = /[a-zA-Z]/;
  if (!regExp1.test(value) || !regExp2.test(value) || value.length < 6 || value.length > 12) {
    return false;
  }
  return true;
};
/**
 * 비밀번호 정규식
 * 영문/숫자/특수문자 조합 n자리 이상
 * @param value
 * @param minLength
 * @returns {boolean}
 */
export const isPasswordValid = (value, minLength) => {
  if (isEmpty(value)) return false;
  const regExp1 = /[0-9]/;
  const regExp2 = /[a-zA-Z]/;
  // eslint-disable-next-line no-useless-escape
  const regExp3 = /['"~․!@#$%^&*()_\-+=\[\]\[\]|;:‘“<>,.?\\/{}]/;
  return !(!regExp1.test(value) || !regExp2.test(value) || !regExp3.test(value) || value.length < minLength);
};
/**
 * 연속된 비밀번호 사용인지 여부 판단
 * @param value
 * @returns {boolean}
 */
export const isContinuousVaild = value => {
  let userPwPassed = true;
  let SamePass0 = 0; // 동일문자 카운트
  let SamePass1 = 0; // 연속성(+) 카운드
  let SamePass2 = 0; // 연속성(-) 카운드
  for (let i = 0; i < value.length; i++) {
    let chrPass0;
    let chrPass1;
    let chrPass2;
    if (i >= 2) {
      chrPass0 = value.charCodeAt(i - 2);
      chrPass1 = value.charCodeAt(i - 1);
      chrPass2 = value.charCodeAt(i);
      // 동일문자 카운트
      if (chrPass0 === chrPass1 && chrPass1 === chrPass2) {
        SamePass0++;
      } else {
        SamePass0 = 0;
      }
      // 연속성(+) 카운드
      if (chrPass0 - chrPass1 === 1 && chrPass1 - chrPass2 === 1) {
        SamePass1++;
      } else {
        SamePass1 = 0;
      }
      // 연속성(-) 카운드
      if (chrPass0 - chrPass1 === -1 && chrPass1 - chrPass2 === -1) {
        SamePass2++;
      } else {
        SamePass2 = 0;
      }
    }

    if (SamePass0 > 0) {
      userPwPassed = false;
    }
    if (SamePass1 > 0 || SamePass2 > 0) {
      alert('영문, 숫자는 3자 이상 연속으로 입력할 수 없습니다.');
      return false;
    }
    if (!userPwPassed) {
      alert('동일 문자를 3자 이상 연속으로 입력할 수 없습니다.');
      return false;
    }
  }
  return true;
};
/**
 * 휴대폰 번호 정규식
 *  - 01012341234 형식 체크
 * @class Util
 */
export const isPhoneValid = value => {
  if (isEmpty(value)) return false;
  let regExp = /^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/;
  return regExp.test(value);
};
export const isValidPhoneNumber = phoneNumber => {
  // 전화번호가 숫자로만 이루어져 있는지 확인
  if (!/^\d+$/.test(phoneNumber)) {
    return false;
  }
  // 전화번호가 10~11자인지 확인
  if (phoneNumber.length < 10 || phoneNumber.length > 11) {
    return false;
  }
  // 전화번호가 010, 011, 016, 017, 018, 019로 시작하는지 확인
  const validPrefixes = ['010', '011', '016', '017', '018', '019'];
  const prefix = phoneNumber.substring(0, 3);
  return validPrefixes.includes(prefix);
};
/**
 * 전화번호 번호 정규식
 * @class Util
 */
export const isTelValid = value => {
  if (isEmpty(value)) return false;
  let regExp = /^[0-9]{3}[0-9]{3,4}[0-9]{4}$/;
  return regExp.test(value);
};

// export const isTelFirstNumber = value => {
//   if (isEmpty(value)) return false;
//   let regExp = /^(010|011|016|017|019)[0-9]{3,4}[0-9]{4}$/;
//   return regExp.test(value);
// };

/**
 * 생년월일 번호 정규식
 *  - YYMMDD 형식 체크
 * @class Util
 */
export const isBirthValid = value => {
  if (this.isEmpty(value)) return false;
  let regExp = /^(?:[0-9]{4}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
  return regExp.test(value);
};
/**
 * 이메일 정규식
 *  - test123@test.com
 * @class Util
 */
export const isEmailValid = value => {
  if (isEmpty(value)) return false;
  // let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
  /*
      세종 Email validation
     */
  let regExp = /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  return regExp.test(value);
};

/**
 * 특정 문자열을 포함하고 있는지 여부를 검사
 * @param value
 * @param expression
 * @returns {boolean}
 */

export const isStringIncludeValid = (value, expression) => {
  if (isEmpty(expression)) return false;
  let regex = new RegExp(expression, 'i'); // 'i' 플래그는 대소문자 구분 없이 검색
  return regex.test(value);
};

/**
 * 최대 글자수 제한 체크
 * @param value
 * @param maxLength
 * @returns {boolean}
 */
export const isMaxLengthValid = (value, maxLength) => {
  if (isEmpty(value)) return false;

  return value.length < maxLength;
};

export default {
  isIdValid,
  isPasswordValid,
  isContinuousVaild,
  isPhoneValid,
  isTelValid,
  isBirthValid,
  isEmailValid
};
